import Dexie from "dexie";

const db = new Dexie("db");

db.version(1).stores({
  products: "id, favorite, cart, *category",
  orders: "id",
});

export { db };
